<template>
  <div class="container">
    <vue-dropzone
      ref="myVueDropzone"
      :include-styling="false"
      :useCustomSlot="true"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-file-added="fileAdded"
      style="width: 100%;"
    >
      <div class="dropzone-container">
        <div class="file-selector" v-if="!json">
          <figure>
            <CloudUploadSvg />
          </figure>
          {{$t('selectJson.dragDropYourJsonFileHere')}}
          <p class="separator"><span> {{$t('selectJson.or')}} </span></p>
          <button type="button">{{$t('selectJson.toSearchFor')}}</button>
        </div>
        <template v-else>
          <div
            class="md-layout"
            style="
              position: relative;
              border-radius: 15px;
              background-color: #f9f9f9;
            "
          >
            <v-row
              no-gutters="no-gutters"
              style="padding: 30px; justify-content: center;"
            >
              <v-col cols="auto">
                <FakeCircularLoader
                  :autoStart="true"
                  @update="loaderFinished($event)"
                />
                <div
                  class="titleLabel colorDark"
                  style="text-align: center; margin-top: 8px;"
                >
                  {{ progressText }} <br />
                </div>
                <div
                  class="titleLabel colorDark"
                  style="
                    text-align: center;
                    margin-top: 8px;
                    font-style: italic;
                  "
                >
                  {{ fileInfoText }}
                </div>
              </v-col>
            </v-row>
            <md-button
              v-if="fileInfo"
              style="position: absolute; top: 0; right: 0;"
              class="md-simple md-github md-just-icon"
              @click="removeFile"
            >
              <md-icon>close</md-icon>
            </md-button>
          </div>
        </template>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import CloudUploadSvg from '@/assets/img/upload-cloud.svg'
import FakeCircularLoader from '@/components/FakeCircularLoader'
export default {
  name: 'SelectJSON',
  data () {
    return {
      json: null,
      fileInfo: null,
      finishedLoading: false,
      dropzoneOptions: {
        // Don't auto aupload the files to the URL.
        autoProcessQueue: false,
        // The Url Where Dropped or Selected files will be sent
        url: `fakeurl`,
        // File Size allowed in MB
        maxFilesize: 102400000,
        // Authentication Headers like Access_Token of your application
        headers: {
          Authorization: `Access Token`
        },
        // The way you want to receive the files in the server
        paramName: function (n) {
          return 'file[]'
        },
        dictDefaultMessage: 'Upload Files Here xD',
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: false,
        acceptedFiles: '.json',
        parallelUploads: 1
      }
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    CloudUploadSvg,
    FakeCircularLoader
  },
  methods: {
    // function called for every file dropped or selected
    async fileAdded (file) {
      // console.log('File Dropped => ', file)
      if (file.type.split('/')[1] === 'json') {
        // Construct your file object to render in the UI
        this.fileInfo = {
          name: file.name,
          size: file.size
        }
        const reader = new FileReader()
        const readJsonPromise = new Promise((resolve) => {
          reader.onload = (evt) => resolve(evt.target.result)
        })
        reader.readAsText(file)
        this.json = await readJsonPromise
      } else {
        Swal.fire({
          title: this.$t('selectJson.invalidFileType'),
          text: this.$t('selectJson.pleaseInsertAJsonFile'),
          type: 'warning',
          confirmButtonClass: 'md-button md-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false
        })
      }
    },
    // called on successful upload of a file
    async loaderFinished (finished) {
      this.finishedLoading = finished
      if (this.finishedLoading) {
        this.$emit('selected-json', this.json)
      }
    },
    removeFile (event) {
      event.stopPropagation()
      this.$emit('selected-json', null)
      this.finishedLoading = false
      this.json = null
      this.fileInfo = null
    }
  },
  computed: {
    progressText () {
      if (!this.fileInfo) return ''
      if (this.finishedLoading) {
        return this.$t('selectJson.readingFinished')
      } else {
        return this.$t('selectJson.readingWorkspace')
      }
    },
    fileInfoText () {
      if (!this.fileInfo) return ''

      const i = Math.floor(Math.log(this.fileInfo.size) / Math.log(1024))
      const sizeText =
        (this.fileInfo.size / Math.pow(1024, i)).toFixed(2) * 1 +
        ' ' +
        ['B', 'kB', 'MB', 'GB', 'TB'][i]
      return `${this.fileInfo.name}(${sizeText})`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-selector {
  padding: 55px;
  font-weight: 600;
  background-color: #f9f9f9;
  color: #4e5b69;
  z-index: -9;
}
figure {
  margin: 0px;
}

.dropzone-container {
  display: flex;
  flex-direction: column;
  border: 1px dashed #ccc;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
button {
  background: #9c27b0;
  box-shadow: 0 0 2px 0 rgba(3, 22, 41, 0.11),
    0 6px 16px 0 rgba(3, 22, 41, 0.08);
  font-family: SFProDisplay-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.4px;
  padding: 12px 30px;
  border-radius: 4px;
}
.separator {
  position: relative;
}
.separator:after {
  position: absolute;
  content: '';
  height: 1px;
  width: 200px;
  background: #d8d8d8;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
span {
  position: relative;
  background: #f9f9f9;
  padding: 0 4px;
  z-index: 9;
  font-size: 12px;
  color: #4e5b69;
}
</style>
